// extracted by mini-css-extract-plugin
export default {"stock-quote-panel":"finance_stock-quote-panel_x"};